import { Sparkles } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative pt-20 min-h-screen flex items-center">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1647381518264-97ff1835026f"
          alt="Professional cleaning service"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
        <div className="max-w-2xl">
          <div className="flex items-center gap-2 mb-6">
            <Sparkles className="text-teal-400" size={32} />
            <span className="text-teal-400 font-semibold text-lg">Wet Area Specialists</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Sparkling Wet Areas,
            <span className="block text-teal-400">Done Right</span>
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed">
            Bathrooms, kitchens and laundries professionally cleaned with care and attention to detail. We specialise in removing grime, mould and built-up dirt, leaving your space fresh, hygienic and looking like new.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              onClick={scrollToBooking}
              size="lg"
              className="bg-teal-600 hover:bg-teal-700 text-white text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all duration-300"
            >
              Book Your Clean
            </Button>
            <Button 
              variant="outline"
              size="lg"
              className="bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-teal-600 text-lg px-8 py-6 transition-all duration-300"
              onClick={() => {
                const element = document.getElementById('services');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Our Services
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 flex flex-wrap items-center gap-8">
            <div className="text-white">
              <div className="text-3xl font-bold">30+ Years</div>
              <div className="text-sm text-gray-300">Cleaning Experience</div>
            </div>
            <div className="text-white">
              <div className="text-3xl font-bold">100%</div>
              <div className="text-sm text-gray-300">Satisfaction Focus</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
